import type { FunctionComponent } from 'react';

/**
 * Generic FOSSA Micro text, wrapped in a <p> tag.
 *
 * @param {React.ReactChild} children - The text to display
 */
const Micro: FunctionComponent = ({ children }) => (
  <p className="fossa-text fossa-text__micro">
    {children}
  </p>
);

export default Micro;
